import React from 'react'
import styled from 'styled-components'
import {
  ActionElement,
  ContextMappingValue,
  InputElement
} from '../../../../../common/types'
import {Modal} from '../../../../../components/library/modal/modal'
import {useActionFlowAnalytics} from '../../../../../lib/analytics/action-flow-analytics'
import {useAFDispatch} from '../../../state/Provider'
import {Fields} from '../../properties'
import {Button} from '../button'
import {Input} from '../input'

const Form = styled.form`
  width: 420px;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const Buttons = styled.div`
  display: flex;
  flex-direction: row-reverse;
  gap: 8px;
  justify-content: flex-start;
`

type BaseProps = {
  mappingId: string
  contextMapping: ContextMappingValue
  handleClose: () => void
  input?: ActionElement | InputElement
  readOnly?: boolean
}
// Must pass one of or the other here
// when updating a card template
type TemplateProps = BaseProps & {
  templateId: string
}
// when updating a step
type StepProps = BaseProps & {
  stepId: string
}
type PlaceholderModalProps = StepProps | TemplateProps

export const PlaceholderModal = ({
  mappingId,
  contextMapping,
  handleClose,
  input,
  readOnly,
  ...props
}: PlaceholderModalProps) => {
  const dispatch = useAFDispatch()
  const {track} = useActionFlowAnalytics()
  const [fallback, setFallback] = React.useState(contextMapping.fallbackValue)

  return (
    <Modal
      title={
        contextMapping.type === 'profile' ? 'Profile value' : 'Step output'
      }
      handleClose={handleClose}
      order="up"
    >
      <Form
        onSubmit={e => {
          e.preventDefault()
          dispatch(
            'templateId' in props
              ? {
                  type: 'update-context-mapping',
                  templateId: props.templateId,
                  mappingId,
                  mapping: {
                    fallbackValue: fallback
                  }
                }
              : {
                  type: 'update-context-mapping',
                  stepId: props.stepId,
                  mappingId,
                  mapping: {
                    fallbackValue: fallback
                  }
                }
          )
          track({
            event: 'Edited action flow context placeholder',
            properties: {
              card_template_id:
                'templateId' in props ? props.templateId : undefined,
              placeholder_type: contextMapping.type
            }
          })
          handleClose()
        }}
      >
        <Fields>
          <Input label="Name" value={contextMapping.display} readOnly />
          {input ? <Input label="Type" value={input.type} readOnly /> : null}
          <Input
            label="Fallback value..."
            value={fallback ?? ''}
            onChange={setFallback}
            readOnly={readOnly}
          />
        </Fields>
        <Buttons>
          {readOnly ? null : <Button type="submit">Save</Button>}
          <Button onClick={handleClose} appearance="secondary">
            {readOnly ? 'Close' : 'Cancel'}
          </Button>
        </Buttons>
      </Form>
    </Modal>
  )
}
